// extracted by mini-css-extract-plugin
export var gatsbyImageWrapper = "GatsbyImage-module--gatsby-image-wrapper--0870a";